import Image from "next/image";

export default function LoaderAnimation() {
  return <Image src={"/akasa_preloader.gif"} alt="payent-loader-gif" width={130} height={130} />;
}
